module.exports = __webpack_public_path__ + "media/images/banner-health-insurance-c2781ec921f6ca10d5153facdd58df2a.jpg";